import { useElement } from './core/element.js';
import './ripple.js';
const name = 's-menu';
const props = {};
const style = `:host{display:flex;flex-direction:column;font-size:.875rem;padding:4px 0;background:var(--s-color-surface-container-low, #F2F4F5)}:host(:nth-of-type(n+2)){border-top:solid 1px var(--s-color-surface-variant, #DCE4E8)}::slotted([slot=label]){display:flex;align-items:center;height:44px;margin:-4px 20px;font-size:.75rem;color:var(--s-color-on-surface-variant, #40484C);white-space:nowrap;max-width:100%;overflow:hidden}`
const template = `<slot name="label"></slot><slot></slot>`
class Menu extends useElement({ style, template, props }) {
}
const itemName = 's-menu-item';
const itemProps = {
    checked: false,
    folded: true
};
const itemStyle = `:host{display:flex;flex-direction:column;margin:4px 8px 4px 0;color:var(--s-color-on-surface, #191C1E)}.container{display:flex;align-items:center;height:40px;border-radius:0 24px 24px 0;padding:0 20px;flex-shrink:0}:host([checked=true]) .container{background:var(--s-color-secondary-container, #CFE6F1);color:var(--s-color-on-secondary-container, #354A53)}.text{flex-grow:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.toggle-icon{width:24px;height:24px;display:none;margin-right:-8px;margin-left:12px;transform:rotate(-90deg);transition:transform var(--s-motion-duration-short4, .2s) var(--s-motion-easing-standard, cubic-bezier(.2, 0, 0, 1));fill:var(--s-color-on-surface-variant, #40484C)}.show-menu .toggle-icon{display:block}:host([folded=false]) .toggle-icon{transform:rotate(0)}.fold{flex-shrink:0}.show-menu+.fold{margin:0 -8px 0 0}.menu{display:block;padding-top:8px}::slotted(:is(svg,s-icon)){color:var(--s-color-on-surface-variant, #40484C);fill:currentColor;height:24px;width:24px}:host([checked=true]) ::slotted(:is(svg,s-icon)){color:currentColor}::slotted([slot]){flex-shrink:0}::slotted([slot=start]){margin-left:-4px;margin-right:12px}::slotted([slot=end]){margin-right:-8px;margin-left:12px}::slotted([slot=menu]){background:var(--s-color-surface-container-high, #E7E8EA)}`
const itemTemplate = `<s-ripple class="container" part="container"><slot name="start"></slot><div class="text" part="text"><slot></slot></div><slot name="end"><svg viewBox="0 -960 960 960" class="toggle-icon"><path d="M480-360 280-560h400L480-360Z"></path></svg></slot></s-ripple><s-fold class="fold" part="fold" folded="${itemProps.folded}"><slot name="menu" class="menu"></slot></s-fold>`
class MenuItem extends useElement({
    style: itemStyle,
    template: itemTemplate,
    props: itemProps,
    syncProps: true,
    setup(shadowRoot) {
        const container = shadowRoot.querySelector('.container');
        const fold = shadowRoot.querySelector('.fold');
        const menu = shadowRoot.querySelector('slot[name=menu]');
        fold.onclick = (event) => event.stopPropagation();
        menu.onslotchange = () => container.classList[menu.assignedElements().length > 0 ? 'add' : 'remove']('show-menu');
        container.onclick = () => {
            if (!container.classList.contains('show-menu'))
                return;
            this.folded = !this.folded;
        };
        return {
            folded: (value) => fold.folded = value
        };
    }
}) {
}
Menu.define(name);
MenuItem.define(itemName);
export { Menu, MenuItem };
